<template src="./html/Withholdings.html"></template>

<script>
	import Withholding from './Withholding'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'withholding': Withholding
		},
		data () {
			return {
				modal: {
					selector: 'modal-invoice-withholdings'
				},
				item: null,
				withholdings: null,
				adding: false,
			}
		},
		mounted() {
			var that = this
			$('#'+this.modal.selector).on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
		methods: {
			add() {
				this.item = {
					invoice_id: this.data.id,
					name: null,
					percent: null,
					value: null,
					before_taxes: false,
				}
				this.adding = true
				this.withholdings.push(this.item)
			},
			remove(item) {
				this.adding = false
				this.withholdings.splice(this.withholdings.indexOf(item), 1)
			},
			reload() {
				this.$emit('reload')
			},
			clearData() {
				this.adding = false
				this.withholdings = null
				this.item = null
			},
			open() {
				this.clearData()
				if(this.data.withholdings) {
					this.withholdings = JSON.parse(JSON.stringify(this.data.withholdings))
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Withholdings.vue